import { compose } from "redux";
import { Link } from "react-router-dom";
import React, { PureComponent } from "react";
import Brightness1 from "@material-ui/icons/Brightness1";
import classNames from "classnames";
import { Grid, Typography, Tooltip, withStyles } from "@material-ui/core";

import { EMPTY_LIST } from "app/app.constants";
import { toEmployeeCard } from "utils/route.util";
import WorkScheduleReportSchedulePeriods from "features/planner/report/workSchedule/components/WorkScheduleReportSchedulePeriods";

class WorkScheduleReportBase extends PureComponent {
  render() {
    const { report, classes, renderDate, dates } = this.props;

    return report
      .get("employeesByGroup", EMPTY_LIST)
      .map((employeesByGroup, groupIndex) => (
        <Grid key={groupIndex} container direction="column">
          <Grid container className={classNames(classes.row, classes.groupRow)}>
            <Grid
              item
              xs={2}
              noWrap
              container
              variant="h6"
              color="primary"
              alignItems="center"
              component={Typography}
              className={classes.groupNameRow}
            >
              {employeesByGroup.get("employeeGroupName")}
            </Grid>
          </Grid>
          {employeesByGroup.get("employees").map(scheduleEmployee => (
            <Grid
              container
              className={classes.row}
              key={scheduleEmployee.get("cardId")}
            >
              <Grid
                item
                xs={2}
                container
                component={Link}
                className={classes.employeeContainer}
                to={toEmployeeCard(scheduleEmployee.get("cardId"))}
              >
                <Grid xs={3} item className={classes.employeeNumber}>
                  <Typography noWrap variant="subtitle2" color="primary">
                    {scheduleEmployee.getIn([
                      "card",
                      "employee",
                      "employeeNumber",
                    ])}
                  </Typography>
                </Grid>
                <Grid
                  xs
                  item
                  container
                  wrap="nowrap"
                  zeroMinWidth
                  alignItems="center"
                  className={classes.employeeName}
                >
                  <Tooltip
                    title={scheduleEmployee.getIn(
                      ["qualification", "name"],
                      "",
                    )}
                  >
                    <Brightness1
                      className={classes.qualificationIcon}
                      style={{
                        fill: scheduleEmployee.getIn(
                          ["qualification", "backColor"],
                          "transparent",
                        ),
                      }}
                    />
                  </Tooltip>
                  <Typography noWrap variant="subtitle2" color="primary">
                    {scheduleEmployee.getIn([
                      "card",
                      "employee",
                      "displayName",
                    ])}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                xs
                item
                container
                wrap="nowrap"
                className={classes.datesContainer}
              >
                {dates.map((date, index) =>
                  renderDate(scheduleEmployee, date, index),
                )}
                {(!!scheduleEmployee.get("deploymentDetails").size ||
                  !!scheduleEmployee.get("scheduleOverrides").size) && (
                  <WorkScheduleReportSchedulePeriods
                    employeeCard={scheduleEmployee}
                    totalDays={report.get("totalDays")}
                    endDate={report.getIn(["parameters", "endDate"])}
                    startDate={report.getIn(["parameters", "startDate"])}
                  />
                )}
              </Grid>
            </Grid>
          ))}
        </Grid>
      ));
  }
}

const styles = theme => ({
  row: {
    height: theme.altus.workScheduleReport.cellSize,
    borderBottom: theme.altus.workScheduleReport.defaultBorder,
  },
  groupRow: {
    position: "sticky",
    background: theme.palette.background.default,
    zIndex: 2,
    top: 102,
  },
  employeeContainer: {
    "&:hover": {
      background: theme.palette.action.hover,
    },
  },
  employeeName: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRight: theme.altus.workScheduleReport.defaultBorder,
  },
  groupNameRow: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  qualificationIcon: {
    marginRight: theme.spacing(0.5),
  },
  employeeNumber: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRight: theme.altus.workScheduleReport.defaultBorder,
  },
  datesContainer: {
    position: "relative",
  },
});

export default compose(withStyles(styles))(WorkScheduleReportBase);
